import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from './config';

// Generic CRUD operations
export const getCollection = async (collectionName, conditions = []) => {
  if (!db) {
    console.warn('Firestore is not configured');
    return [];
  }
  
  try {
    const collectionRef = collection(db, collectionName);
    let q = collectionRef;
    
    if (conditions.length > 0) {
      q = query(collectionRef, ...conditions);
    }
    
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting collection:', error);
    throw error;
  }
};

export const getDocument = async (collectionName, docId) => {
  if (!db) {
    console.warn('Firestore is not configured');
    return null;
  }
  
  try {
    const docRef = doc(db, collectionName, docId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    }
    return null;
  } catch (error) {
    console.error('Error getting document:', error);
    throw error;
  }
};

export const addDocument = async (collectionName, data) => {
  if (!db) {
    throw new Error('Firestore is not configured');
  }
  
  try {
    const docRef = await addDoc(collection(db, collectionName), {
      ...data,
      createdAt: serverTimestamp()
    });
    return docRef.id;
  } catch (error) {
    console.error('Error adding document:', error);
    throw error;
  }
};

export const updateDocument = async (collectionName, docId, data) => {
  if (!db) {
    throw new Error('Firestore is not configured');
  }
  
  try {
    const docRef = doc(db, collectionName, docId);
    await updateDoc(docRef, {
      ...data,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error('Error updating document:', error);
    throw error;
  }
};

export const deleteDocument = async (collectionName, docId) => {
  if (!db) {
    throw new Error('Firestore is not configured');
  }
  
  try {
    await deleteDoc(doc(db, collectionName, docId));
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
};

// Helper functions
export { where, orderBy };
